import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CmsUiPortfolioContent } from '@lobos/library';
import { NgxMasonryOptions } from 'ngx-masonry';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioComponent implements OnInit {
  @Input() data!: CmsUiPortfolioContent;
  @Input() ordered = true;

  public masonryOptions: NgxMasonryOptions | undefined;

  public ngOnInit(): void {
    this.masonryOptions = {};
  }
}
